<template>
  <div>
    <commBanner :obj="obj"></commBanner>
    <titleHead :headTitle="headTitle"></titleHead>
    <div class="w80 mb-50">
      <el-container>
        <el-aside width="330px">
          <sidebar></sidebar>
        </el-aside>
        <el-main>
          <comentTitle
            :comentTitle="comentTitle"
            :comentText="comentText"
            @onEitd="onEitdMes()"
          ></comentTitle>
          <!--专家账号基本信息-->
          <div class="expert_meacl">
            <div class="expert_brief">
              <div class="expert_portrait">
                <img
                  class="portrait_img"
                  :src="expert.headUrl"
                />
                <!--小图标-->
                 <div  class="exper_icon">
                   <img v-if="isImg == true"  src="@/assets/images/mer_vip.png" alt="">
                   <img v-if="isExpert == true" src="@/assets/images/expert_vip.png" alt="">
                   <span :class="[ portText =='个人'?'color_1':'color_2']">{{portText}}</span>
                 </div>

                 <!-- <img class="mer"
               :src="[status ==1?require('@/assets/images/greenMern.jpg'):require('@/assets/images/member.png')]" alt="" /> -->
              </div>
              <div style="flex: 1; margin-left: 47px; margin-top: 52px">
                <div class="expert_wer">
                  <span class="user_name">{{expert.name}}</span>
                  <span class="user_text" @click="onGead()">{{personStatus(expert.status)}}</span>
                  <!-- <button class="release" @click="onRelease()">我要发布</button> -->
                </div>
                <div class="synopsis">
                  <p class="mt-20">
                    <span>联系电话&nbsp;:</span>
                    <span style="margin-left: 5px">{{expert.mobile}}</span>
                  </p>
                  <p class="mt-20">
                    <span>邮&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;箱&nbsp;:</span>
                    <span style="margin-left: 5px">{{expert.email}}</span>
                  </p>
                </div>
              </div>
            </div>
            <div class="expery">
              <div class="expery_marte">
                 <div class="expery_patr ml-44">
                    <div>
                     <span class="expery_font">总收入：</span>
                     <span style="color: #ff7402;margin-left:-10px;">￥</span>
                     <span class="experys_font">{{tranNumber(balaInfo.total_income)}}</span>
                    </div>
                     <div class="mt-10 fsb">
                      <span class="expery_font">地&nbsp;&nbsp;&nbsp;区：</span>
                      <span class="expery_wetr" v-if="expert.location" >{{expert.location.replace(/,/g,'/')}}</span>
                    </div>
                 </div>
                 <div class="expery_patr ml-40">
                  <div class="mt-6 ">
                    <span class="expery_font">余额：</span>
                    <span class="expery_fonts ml-10">￥{{tranNumber(balaInfo.balance)}}</span>
                  </div>
                <div class="mt-10 fsb">
                  <span class="expery_font">职&nbsp;&nbsp;&nbsp;业：</span>
                  <span class="expery_even">{{expert.job}}</span>
                </div>
                 </div>
                 <div class="expery_patr ml-40">
                <div class="mt-6">
                  <span class="expery_font">已提现：</span>
                  <span class="expery_fonts ml-10">￥{{tranNumber(balaInfo.withdraw)}}</span>
                </div>
                <div class="mt-10 fsb">
                  <span class="expery_font">所属行业：</span>
                  <span class="expery_fonts">{{expert.industryStr}}</span>
                </div>
                 </div>
              </div>
              <div class="expery_patrs">
                <span class="expery_font">就职单位：</span>
                <span class="expery_evens">{{expert.hobby}}</span>
              </div>
            </div>
          </div>
          <div class="mt-30">
            <contTitle :obj="obj" :contTitle="contTitle1"></contTitle>
            <div class="numer_conent" v-html="expert.detail">
            </div>
          </div>
          <div v-show="userType" class="mt-30">
              <contTitle
              class="mt-30"
              :obj="obj"
              :contTitle="contTitle2"
             ></contTitle>
            <div class="mt-20">
              <el-carousel
                :interval="4000"
                type="card"
                :autoplay="false"
                height="200px"
                width="800px"
                indicator-position="none"
              >
                <el-carousel-item v-for="(item, index) in list" :key="index">
                  <viewer>
                    <img class="viewer_img" :src="item.url" />
                  </viewer>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
        </el-main>
      </el-container>
    </div>
  </div>
</template>
<script>

import {question} from '@/api/expert'
import {myfunds} from '@/api/coment'
import {getBanner} from '@/api/information'
import sidebar from "../../common/sidebar";
import commBanner from "../../common/commBanner";
import titleHead from "../../common/titleHead";
import comentTitle from "../../common/comentTitle";
import contTitle from "../../common/contTitle";
export default {
  components: { sidebar, commBanner, titleHead, comentTitle, contTitle },
  data() {
    return {
      headTitle: "专家帐户",
      comentTitle: "个人基本信息",
      comentText: "编辑个人信息   >",
      contTitle1: "个人详细信息",
      contTitle2: "资质证书",
      obj: {
        title: "专家帐户",
        isShow: false,
        isNumber: false,
        roleType:'',
        personalType:9
      },
      expert:{},
      list:[],
      status:1,
      userType:false,
      balaInfo:{},
      portText:'',
      status:'',
      statusList: ["待认证", "认证通过", "认证拒绝"],
      isImg:false,
      isExpert:false,
      Type:''
    };
  },
  created(){
    this.getMyfunds();
    this.getMate();
    this.expert = this.$store.state.user.userInfo.data;
    this.status = this.$store.state.user.userInfo.data.status;
    this.job = this.$store.state.user.userInfo.type;
    let type = this.$store.state.user.userInfo.type;
    switch(type){
      case 1:
        this.headTitle = '个人账户';
        this.obj.title = '个人账户';
        this.obj.roleType = type;
        break;
      case 2:
        this.userType = true;
        this.obj.roleType = type;
        this.list = this.expert.certifications !=''?JSON.parse(this.expert.certifications):'';
        break;
       default:
         break;
    }
      let id = this.$store.state.user.userInfo.data2.id;
      switch(id){
		    case 1:
		     this.isImg = false;
		     break;
        case 2:
          this.portText ='个人';
          this.isImg = true;
          break;
		    case 3:
		      this.portText = '专家'
		      this.isExpert = true;
		      break;
      }
  },
  methods: {
    //编辑个人信息
    onEitdMes(){
      this.$router.push('/personal_information')
    },
    //发布需求
    onRelease(){
      this.$router.push('/demand')
    },
    //获取用户余额
    getMyfunds(){
      myfunds().then((res)=>{
        if(res.code ==0){
          this.balaInfo = res.data;
        }
      }).catch((err)=>{});
    },
    personStatus(status){
      if(status == null || status == -1){
        status = 0;
      }
      return this.statusList[status];
    },
    getMate(){
        var metas = document.getElementsByTagName("meta");
        document.getElementsByTagName("title")[0].innerText= this.$route.meta.title +'_智污邦环保服务平台';
    },
    tranNumber(num){
      // num = Number(num);
      if (num == 0) {
        return num + '';
      } else
      if (num > 1 && num < 10000) {
        return num + '';
      } else {
        return (num / 10000).toFixed(2) + '万';
      }
    },
    onGead(){
      if(this.status == -1 || this.status == 0){
        this.$router.push({
		    path:'/membership',
		  	query:{type:1}
		 })
      }
    }
  },
};
</script>
<style scoped="scoped">
.el-aside {
  height:100%;
}
.mt-10 {
  margin-top: 10px;
}
.mt-15 {
  margin-top: 15px;
}
.mt-20 {
  margin-top: 20px;
}
.mb-50 {
  margin-bottom: 50px;
}
.mt-6{
  margin-top: 6px;
}
.ml-5{
  margin-left: 5px;
}
.ml-10{
  margin-left: -10px;
}
.ml-44{
  margin-left: 44px;
}
.ml-40{
  margin-left: 40px;
}
.w42{
  width: 42px;
}
.fsb{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.expert_meacl {
  width: 100%;
  border-left: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
  border-right: 1px solid #eeeeee;
  border-top: 2px solid #99cf2a;
  margin-top: 30px;
  display: flex;
  flex-direction: column;
}
.expert_brief{
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
.expert_portrait{
  width: 150px;
  height: 150px;
  margin-left: 32px;
  margin-top: 30px;
  position: relative;
  /* border-radius: 50%;  */
}
.portrait_img {
  width: 149px;
  height: 147px;
  border-radius: 50%;
}
.exper_icon{
  position: absolute;
  top: 97px;
  right: -9px;
}
.exper_icon img{
  width: 32px;
  margin-right: -21px;
  margin-top: 10px;
}
.exper_icon span{
  font-size: 12px;
}
.color_1{
  color: #75B215;
}
.color_2{
  color: #1296db;
}
.viewer_img{
  height: 180px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
}
.mer{
  position: absolute;
  top: 134px;
  left: 149px;
  z-index: 100 !important;
}
.expert_wer {
  display: flex;
  /* justify-content: space-between; */
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid #f2f2f2;
  padding-bottom: 15px;
  margin-right: 30px;
}
.expery{
  display: flex;
  flex-direction: column;
  margin: 20px 0px;
}
.expery_patr{
  text-align: left;
  display: flex;
  font-size: 14px;
  flex-direction: column;
  width: 27%;
}
.expery_marte{
  display: flex;
  justify-content: flex-start;
}
.expery_patrs{
  font-size: 14px;
  display: flex;
  justify-content:flex-start;
  align-items: center;
  margin: 10px 44px;
}
.expery_font{
  font-size:14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
}
.expery_wetr{
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
  /* width: 104px; */
  text-overflow: ellipsis;
  overflow: hidden;
  flex: 1;
  white-space: nowrap;
}
.expery_fonts{
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
  flex: 1;
}
.expery_even{
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
  overflow: hidden;
  /* width: 120px; */
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
}
.expery_evens{
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
  overflow: hidden;
  width: 62%;
  text-align: left;
  display: inline-block;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.experys_font{
  font-size: 24px;
  font-family: Arial;
  font-weight: 400;
  color: #FF7402;
}

.user_name {
  width: 16%;
  height: 33px;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
  line-height: 38px;
  padding-bottom: 16px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 15px;
}
.user_text{
  width: 61px;
  height:27px;
  line-height: 27px;
  border-radius:3px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #9a9a9a;
  display: inline-block;
  margin-top: 5px;
  border: 1px solid #eeeeee;
}
.user_text:hover{
  cursor: pointer;
}
.release {
  width: 114px;
  height: 35px;
  background: #68be32;
  border-radius: 3px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
.synopsis {
  display: flex;
  flex-direction: column;
  text-align: left;
}

.numer_conent {
  text-align: left;
  margin-top: 20px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
  height: 500px;
  overflow: auto;
}

.numer_conent >>>p.MsoNormal{
  text-align: left !important;
  text-indent:0px !important;
  word-wrap:break-word;
  word-break:normal;
}

.numer_conent >>>p span{
  word-wrap:break-word;
  word-break:normal;
}
.numer_conent>>>img{
  width: 100%;
  height: 300px;
}
.numer_conent >>>p{
  margin-bottom: 15px;
}
.numer_conent>>>p span{
  background-color: #fff !important;
  font-size: 16px !important;
}
.number_img {
  margin-top: 20px;
}
.number_img img {
  width: 100%;
}
.natural {
  width: 195px;
}
.naturals {
  height: 169px;
}
/**轮播样式 */
.expert_swipe >>> .el-carousel__container {
  height: 180px;
  width: 800px;
}
.expert_swipe >>> .el-carousel__button {
  width: 5px;
  height: 5px;
  border-radius: 50%;
}
.expert_swipe >>> .el-carousel__item:nth-child(2n) {
  background-color: #ffffff;
}

.expert_swipe >>> .el-carousel__item:nth-child(2n + 1) {
  background-color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/view/coment/number.vue